import { render, staticRenderFns } from "./MultiSelectProductTag.vue?vue&type=template&id=403db697&"
import script from "./MultiSelectProductTag.vue?vue&type=script&lang=js&"
export * from "./MultiSelectProductTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports